import { PayloadAction } from "@reduxjs/toolkit";

import { MyFleetState } from "../../types";

export const setSortOrder = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState["sortOrder"]>
) => {
  state.sortOrder = action.payload;
};
